// extracted by mini-css-extract-plugin
export default {"StaticContentFieldFormItemLabel":"StaticContentField_StaticContentFieldFormItemLabel__ik1Ul","StaticContentFieldDivider":"StaticContentField_StaticContentFieldDivider__RKstd"};